import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Помечает HTTP-запрос как «ошибки обрабатываю сам».
 * TokenInterceptor тогда НЕ показывает глобальный тост и НЕ глотает ошибку
 * (возвращая of()), а прокидывает её дальше — чтобы вызывающий код (например,
 * визард импорта U-ON) мог показать собственное состояние ошибки/пустого
 * результата. 401-рефреш токена при этом продолжает работать.
 */
export const SKIP_GLOBAL_ERROR = new HttpContextToken<boolean>(() => false);

/**
 * Помечает запрос как «401 — это бизнес-ошибка, НЕ истёкший access-токен».
 * TokenInterceptor тогда НЕ запускает на 401 ветку refresh+retry. Нужно для эндпоинтов,
 * где 401 означает предметный отказ (например link-email/confirm → «Неверный код»):
 * без флага интерцептор на каждый неверный код зря ротировал бы refresh-токен И повторял
 * тот же неверный код, расходуя удвоенно бюджет локаута (порог 8 срабатывал бы за ~4 клика).
 */
export const SKIP_401_REFRESH = new HttpContextToken<boolean>(() => false);

/** Хелпер: контекст запроса с включённым флагом «свои ошибки». */
export function skipGlobalErrorContext(): HttpContext {
  return new HttpContext().set(SKIP_GLOBAL_ERROR, true);
}

/**
 * Контекст для эндпоинтов, которые сами обрабатывают ошибки И у которых 401 — предметный
 * отказ, а не истечение токена (свои ошибки + без авто-refresh на 401).
 */
export function selfHandledAuthContext(): HttpContext {
  return new HttpContext()
    .set(SKIP_GLOBAL_ERROR, true)
    .set(SKIP_401_REFRESH, true);
}
